<div mat-dialog-title class="confirmHeader p-2 mt-2 d-flex justify-content-center">
    <img [src]="icon" alt="Warning" class="warning-popup-icon">
</div>
<div class="d-flex justify-content-center" *ngIf="data.header && data.header !='Extraction Procedure'">
    <div class="main-line-text">{{data.header}}</div>
</div>
<span class="migrate_wrap">
    <div mat-dialog-content class="confirm-content">
        <span [innerText]="data.message" class="main-line-text"></span>

        <!-- Username display for Activate/Deactivate Account actions -->
        <span *ngIf="(data.action === 'Activate Account' || data.action === 'Deactivate Account') && data.username"
            class="d-flex justify-content-center mt-2">
            <span class="sub-line-text">
                {{data.username}}
                <span *ngIf="data.role">
                    <strong class="ml-1">({{data.role}})</strong>
                </span>
            </span>
        </span>

        <!-- Username display for Delete action -->
        <!-- <span *ngIf="data.action === 'Delete' && data.username" class="d-flex justify-content-center mt-2">
          <span class="sub-line-text user-font-size">{{data.username || 'User'}}</span>
        </span> -->

        <h5 *ngIf="data.alert" class="sub-line-text">{{data.alert}}</h5>
        <span class="sub-line-text" *ngIf="ifExists(data.message)">You cannot revert this action.</span>
        <h6 class="sub-line-text" *ngIf="data.notes">{{data.notes}}</h6>
        <section *ngIf="data.action && (data.action !== 'Activate Account' && data.action !== 'Deactivate Account')"
            class="example-section">
            <mat-checkbox class="example-margin" [color]="'primary'" (change)='onCheckboxClick($event.checked)'>
                {{data.action}}</mat-checkbox>
        </section>
    </div>
</span>

<div mat-dialog-actions class="confirm_dia d-flex justify-content-center"
    [ngClass]="{'pb-4': data.alert && data.alert.includes('previous record will be unmarked')}"
    [ngStyle]="{'justify-content': data.cancel === 'dontshow' ? 'center':''}">
    <app-button *ngIf="data.cancel !== 'dontshow'" buttonclass="secondary" class="mr-2 popup-btn" customClass="admin"
        mat-dialog-close>{{data.cancel}}</app-button>

    <!-- Delete button when continue is 'Delete' -->
    <app-button *ngIf="data.header !='Extraction Procedure' && data.continue && data.continue === 'Delete'"
        class="popup-btn delete-button" customClass="admin"
        [isDisabled]="isContinueDisabled()"
        (click)="onNoClick()">{{data.continue}}</app-button>

    <!-- Regular primary button for all other cases -->
    <app-button *ngIf="data.header !='Extraction Procedure' && data.continue && data.continue !== 'Delete'"
        buttonclass="primary" class="popup-btn" customClass="admin"
        [isDisabled]="isContinueDisabled()"
        (click)="onNoClick()">{{data.continue}}</app-button>

    <div *ngIf="data.header == 'Extraction Procedure'" class="d-flex ml-4">
        <mat-icon role="img" class="align-items-center redirect-icon">launch</mat-icon>
        <a class="redirect-btn mr-3" (click)="onNoClick()"> {{data.continue}}</a>
    </div>
</div>